import * as React from 'react';
// oxlint-disable-next-line cian-eslint-compat/no-extraneous-dependencies
import { clsx } from 'clsx';

import * as styles from './Dot.css';

interface IDotProps {
  active?: boolean;
  size: 'S' | 'M' | 'L';
}

const DotComponent: React.FC<IDotProps> = ({ active, size }) => {
  return (
    <li
      className={clsx(styles['container'], styles[`container--size-${size.toLowerCase()}`], {
        [styles['container--active']]: active,
      })}
    />
  );
};

export const Dot = React.memo(DotComponent);
